import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';

function FinishBookingComponent() {
  const history = useHistory();
  const { language } = useParams();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    // const responseCode = params.get('vpc_AcqResponseCode');
    const bookingNumber = params.get('vpc_MerchTxnRef');

    history.push(`/${language}/booking-confirm/${bookingNumber}`);
    // if (responseCode === '00') {
    // } else {
    //   history.push(`/${language}/`);
    // }

    // eslint-disable-next-line
  }, []);

  return <div>Finish booking...</div>;
}

export default FinishBookingComponent;
